import { render, staticRenderFns } from "./RiskPeriodSummary.html?vue&type=template&id=ea8b9094&external"
import script from "./RiskPeriodSummary.vue?vue&type=script&lang=js"
export * from "./RiskPeriodSummary.vue?vue&type=script&lang=js"
import style0 from "./RiskPeriodSummary.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports